import {
  Button, Card, CardContent,
  CardHeader,
  CircularProgress, Container,
  Dialog,
  DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider,
  FormControl,
  Grid,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer, TableHead,
  TableRow
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser, moneyFormat, sc } from 'src/utils/Common';
import logger from 'src/utils/logger';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  contentMaterialImage: {
    padding: 5,
    minHeight: 580,
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  container: {
    maxHeight: 440,
  },
}));

// materialTheme and localeMap removed (not used in this view)

function WareHouseControl() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const Uyari = "";
  const [ResponseData, setResponseData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [ResponseDataFull, setResponseDataFull] = React.useState([]);
  const [ResponseDataDetail, setResponseDataDetail] = React.useState([]);
  const [baslangicTarihi] = useState(moment().subtract(30, 'days').format("YYYY-MM-DD"));
  const [bitisTarihi] = useState(moment().format("YYYY-MM-DD"));
  const [TeknisyenValue, setTeknisyenValue] = useState(0);
  const [TeknisyenData, setTeknisyenData] = useState([]);





  const SessionUser = getUser();
  const handleClose = () => {
    setOpen(false);
  };

  // handleDateChange removed (no date pickers in this view)
  const handleSearch = () => {
    setLoading(true);
    setTeknisyenValue(0);
    axios.get('/GetDepoZimmetRapor/' + SessionUser.ServiceShopId + '/' + SessionUser.OrganizationUserId + '/' + baslangicTarihi + '/' + bitisTarihi)
      .then(response => {
        const Data = response.data;
        if (Data.length === 0) {
          setResponseData([]);
        } else {
          setResponseData(Data);
        }
        setLoading(false);
      }).catch(error => {
        setResponseData([]);
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
    axios.get('/GetDepoZimmetRaporDetail/' + SessionUser.ServiceShopId + '/' + SessionUser.OrganizationUserId + '/' + baslangicTarihi + '/' + bitisTarihi)
      .then(response => {
        const Data = response.data;
        if (Data.length === 0) {
          setResponseDataDetail([]);
          setResponseDataFull([]);
        } else {
          setResponseDataDetail(Data);
          setResponseDataFull(Data);
          var TeknisyenData1 = [];

          Data.forEach(item => {
            const kontrol = TeknisyenData1.filter(d => d.KUL_TEK_KODU === item.KUL_TEK_KODU);
            if (kontrol.length === 0) {
              TeknisyenData1.push({ 'KUL_TEK_KODU': item.KUL_TEK_KODU, 'TEKNISYEN': item.KUL_TEK_KODU + ' ' + item.ADI + ' ' + item.SOYADI })
            }
          });
          setTeknisyenData(TeknisyenData1);
        }
        setLoading(false);
      }).catch(error => {
        setResponseDataDetail([]);
        setResponseDataFull([]);
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
  }

  useEffect(() => {
    var todosData1 = [];
    todosData1 = ResponseDataFull.filter(function (item) {
      return (
        sc(item.KUL_TEK_KODU, TeknisyenValue)
      );
    });
    setResponseDataDetail(todosData1);
    // eslint-disable-next-line
  }, [TeknisyenValue]);

  const handleChangeTeknisyen = (e) => {
    setResponseDataDetail([]);
    setTeknisyenValue(e.target.value);

  }

  return (
    <Page className={classes.root} title="Depo Zimmet">
      <Container maxWidth="lg">
        <Header />
        <Card>
          <CardHeader title="Depo Zimmet" />
          <Divider />
          <CardContent>
            {loading && <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />}
            <br />
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <FormControl variant="outlined" fullWidth className={classes.formControl}>
                  <Select
                    native
                    onChange={(e) => handleChangeTeknisyen(e)}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    fullWidth
                    value={TeknisyenValue}>
                    <option value="0" defaultValue="0">Teknisyen Seçiniz!...</option>
                    {TeknisyenData.map(p => {
                      return <option key={p.KUL_TEK_KODU} value={p.KUL_TEK_KODU}>{p.TEKNISYEN}</option>
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitMaterialImage}
                  onClick={() => handleSearch()}
                  endIcon={<SearchIcon />}>
                  Sorgula
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <br />
        <Card>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableBody>
                <TableRow>
                  <TableCell align='right'><b>Stok Çeşidi</b></TableCell>
                  <TableCell align='right'>{ResponseData[0]?.CESIT}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='right'><b>Stok Tutarı (Alım)</b></TableCell>
                  <TableCell align='right'>{ResponseData[0]?.ALISKDVSIZ}₺</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='right'><b>Stok Tutarı (Satış)</b></TableCell>
                  <TableCell align='right'>{ResponseData[0]?.SATISKDVSIZ}₺</TableCell>
                </TableRow>
              </TableBody>
            </Table>

          </TableContainer>
        </Card>
        <br />
        <Card>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Teknisyen</TableCell>
                  <TableCell align='right'>Çeşit</TableCell>
                  <TableCell align='right'>Adet</TableCell>
                  <TableCell align='right'>Fiyat</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ResponseDataDetail.map(row => (
                  <TableRow key={row.KUL_TEK_KODU}>
                    <TableCell>{row.KUL_TEK_KODU} {row.ADI} {row.SOYADI}</TableCell>
                    <TableCell align='right'>{row.CESIT}</TableCell>
                    <TableCell align='right'>{row.ADET}</TableCell>
                    <TableCell align='right'> {
                      moneyFormat(
                        row.FIYAT,
                        'try',
                        'try'
                      )}₺</TableCell>


                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description" >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default WareHouseControl;
